













import { Component, Prop, Vue } from "vue-property-decorator";

import * as def from "@/definitions";

import { Layer } from "@/model/document2/page/surface/design/layer/layer";
import { GroupLayer } from "@/model/document2/page/surface/design/layer/groupLayer";

import { Treenode } from "@/definitions/treenode"

import GroupLayerView from "./groupLayerView/groupLayerView.vue"
import SingleLayerView from "./singleLayerView/singleLayerView.vue"

@Component({
  components: {
      SingleLayerView,
    GroupLayerView
  }
})
export default class GrabbedLayerView extends Vue {

  @Prop()
  private treeNode!: Treenode;
  @Prop()
  private draggingPosition!: {
      left : 0,
      top : 0
  };

  get  nodeStyle(){
      return {
          left : (this.draggingPosition.left - 160) + "px",
          top : this.draggingPosition.top + 5 + "px"
      }
  }

}
